import { Culture } from '@core/index';
import Translate from '@service/Translate';
import Num2Persian from '@utilize/Num2Persian';
import { FC } from 'react';
import ContentLoader from 'react-content-loader';

interface IPriceProps {
    prefixSymbol?: string;
    currencyUnitVisiblity?: boolean;
    currencyUnitShort?: boolean;
    amount?: number;
    numToPersian?: boolean;
    amountFontSize?: string;
    currencyFontSize?: string;
    amountColor?: string;
    currencyColor?: string;
    zeroText?: string;
    className?: string;
}

const Price: FC<IPriceProps> = (props) => {
    const {
        prefixSymbol,
        currencyUnitVisiblity,
        amountFontSize,
        currencyFontSize,
        amountColor,
        currencyColor,
        amount,
        numToPersian = false,
        zeroText,
        currencyUnitShort,
        className = ""
    } = props;
    const { tr } = Translate;
    const {dir} = Culture.getLocale();
    const price = priceFormatter(Math.floor(amount || 0));
    const pricingSkeleton = <div className="skeleton">
        <ContentLoader
            width="100%"
            height="100%"
            title={tr("msg_availability_flights_loading")}
            speed={1}
            backgroundColor="#d9d9d9"
            foregroundColor="#ecebeb"
            rtl={dir === "rtl"}
            className="skeleton-search-result-section"
        >
            {/* Only SVG shapes */}
            <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
        </ContentLoader>
    </div>
    return (
        <div className={`price ${className}`}>
            {
                amount === undefined || Number.isNaN(amount) ?
                    pricingSkeleton
                    :
                    price !== "0" ?
                        <>
                            <span
                                className={`amount${prefixSymbol ? " dir-ltr" : ""}`}
                                style={{ fontSize: amountFontSize ? amountFontSize : "", color: amountColor ? amountColor : "inherit" }}
                            >
                                {prefixSymbol ? <span className="sign">{prefixSymbol}</span> : ""}
                                {
                                    price && numToPersian ? Num2Persian(price)
                                        : price
                                }
                            </span>
                            {
                                currencyUnitVisiblity ?
                                    <span className="currency" style={{ fontSize: currencyFontSize ? currencyFontSize : "", color: currencyColor ? currencyColor : "inherit" }}>
                                        {currencyUnitShort ? Culture.getLocale().currency.abbreviation : Culture.getLocale().currency.displayText}
                                    </span> : ""
                            }
                        </>
                        :
                        zeroText ? <span>{zeroText}</span> :
                            currencyUnitVisiblity ?
                                <>
                                    <span style={{ fontSize: amountFontSize ? amountFontSize : "", color: amountColor ? amountColor : "inherit" }}>{price}</span>
                                    <span className="currency" style={{ fontSize: currencyFontSize ? currencyFontSize : "", color: currencyColor ? currencyColor : "inherit" }}>
                                        {currencyUnitShort ? Culture.getLocale().currency.abbreviation : Culture.getLocale().currency.displayText}
                                    </span>
                                </>
                                :
                                <span style={{ fontSize: amountFontSize ? amountFontSize : "", color: amountColor ? amountColor : "inherit" }}>{price}</span>

            }
        </div>
    )
}

export default Price;

export function priceFormatter(amount: number = 0) {
    let price: string = "0";
    if (amount)
        price = (Math.trunc(amount) * (Culture.getLocale().currency.ratio || 1)).toLocaleString();
    return price;

}